export const SIDEBAR_WIDTH = 260;
/**
 * Centralized theme provider for all components that use EmburseThemeProvider
 * This class should convert the Abacus style config to Emburse format and pass it off to the provider
 *
 * @export
 * @class AbacusThemeProvider
 */
class AbacusThemeProvider {
    /**
     * Returns Abacus Theme Options
     *
     * @static
     * @return {*}
     * @memberof AbacusThemeProvider
     */
    static getThemeOptions() {
        var _a, _b, _c;
        const { whitelabelConfiguration } = window;
        return {
            palette: {
                monochrome: {
                    main: (_a = whitelabelConfiguration === null || whitelabelConfiguration === void 0 ? void 0 : whitelabelConfiguration.tags) === null || _a === void 0 ? void 0 : _a.secondaryColorCode
                },
                primary: {
                    main: (_b = whitelabelConfiguration === null || whitelabelConfiguration === void 0 ? void 0 : whitelabelConfiguration.tags) === null || _b === void 0 ? void 0 : _b.primaryColorCode
                },
                secondary: {
                    main: (_c = whitelabelConfiguration === null || whitelabelConfiguration === void 0 ? void 0 : whitelabelConfiguration.tags) === null || _c === void 0 ? void 0 : _c.secondaryColorCode
                }
            },
            sizes: {
                sidebar: {
                    width: SIDEBAR_WIDTH
                }
            },
            breakpoints: {
                values: {
                    xs: 0,
                    sm: 600,
                    md: 900,
                    lg: 1180,
                    xl: 1536
                }
            }
        };
    }
}
export { AbacusThemeProvider };
